import instantsearch from 'instantsearch.js';
import { configure, searchBox, clearRefinements, hits } from 'instantsearch.js/es/widgets';
import { history } from 'instantsearch.js/es/lib/routers';
import searchClient from '@pratt/js/components/algolia/search-client';
import { HitHelpers } from '@pratt/js/components/algolia/hit-helpers';
import { customPagination } from '@pratt/js/components/algolia/pagination';
import { refinementListWithPanel } from '@pratt/js/components/algolia/panel';
import Accordion from '@pratt/js/components/accordion';
import { refinementListTemplate } from '@pratt/js/components/algolia/templates/refinement-list';

class CourseSearch {
  constructor(rootEl) {
    this.rootEl = rootEl;
    if (!this.rootEl) {
      throw new Error('Root course search element not found.');
    }

    this.hitsPerPage = 24;

    this.search = instantsearch({
      indexName: this.rootEl.dataset['algoliaIndex'],
      searchClient: searchClient,
      routing: {
        router: history({
          cleanUrlOnDispose: true,
        }),
      },
      insights: true,
      future: {
        preserveSharedStateOnUnmount: true,
      },
    });

    this.search.on('render', function() {
      document.querySelectorAll('.js-accordion-trigger').forEach(trigger => new Accordion(trigger));
    });
    this.init();
    this.search.start();
  }

  init() {
    this.search.addWidgets([
      // https://www.algolia.com/doc/api-reference/widgets/configure/js/
      // Parameter options: https://www.algolia.com/doc/api-reference/search-api-parameters/
      configure({
        hitsPerPage: this.hitsPerPage,
        distinct: true,
        // Force faceting to be applied after de-duplication (via the Distinct setting)
        facetingAfterDistinct: true,
        // Filter results by 'type' facet
        // https://www.algolia.com/doc/api-reference/api-parameters/filters/#facet-filters
        filters: `type:"course"`,
      }),

      searchBox({
        container: '.js-course-search-input',
        placeholder: 'Search Courses',
        showSubmit: false,
      }),

      clearRefinements({
        container: '.js-course-search-clear',
        templates: {
          resetLabel: 'Reset',
        },
      }),

      refinementListWithPanel('School')({
        container: '.js-course-search-schools-input',
        attribute: 'schools',
        operator: 'and',
        limit: 10,
        showMore: true,
        showMoreLimit: 100,
        sortBy: ['name:asc'],
        templates: {
          item: refinementListTemplate,
        },
      }),

      refinementListWithPanel('Department')({
        container: '.js-course-search-departments-input',
        attribute: 'departments',
        operator: 'and',
        limit: 10,
        showMore: true,
        showMoreLimit: 100,
        sortBy: ['name:asc'],
        templates: {
          item: refinementListTemplate,
        },
      }),

      // https://www.algolia.com/doc/api-reference/widgets/hits/js/
      hits({
        container: '.js-course-search-hits',
        templates: {
          /* eslint-disable */
          item(hit) {
            // prettier-ignore
            return `
              <div class="accordion js-accordion-block">
                <h2 class="course-hit__title accordion__title" onClick="if(!checkOpen(this)) { sendEvent('click','${hit.type} expanded', '${hit.objectID}', '${hit.__queryID}', ${hit.__position});  }">
                  <button class="js-accordion-trigger accordion-trigger-${hit.objectID}" data-collapsible="${hit.objectID}" aria-expanded="false" aria-hidden="true">
                    <div class="course-hit__text-wrapper">
                      <span>
                        <span class="accordion-head-title">${hit.code} ${hit.title}</span>
                      </span>
                      ${hit.credits ? `
                        <div class="course-hit__credits">
                          ${hit.credits} credit${hit.credits === 1 ? '' : 's'}
                        </div>
                      ` : ''}
                    </div>
                  </button>
                </h6>

                <div id="${hit.objectID}" aria-hidden="true" class="accordion__content course-hit__details">
                  ${hit.description ? `
                    <div class="course-hit__description">${hit.description}</div>
                  ` : ''}
                  ${HitHelpers.Courses.sectionsAsHtml(hit)}
                  <div class="course-hit__visit">
                    <a class="course-hit__link" href="${hit.url}" onClick="sendEvent('click','${hit.type} clicked', '${hit.objectID}', '${hit.__queryID}', ${hit.__position})">
                      <button class="course-hit__link-button">Visit the course</button>
                    </a>
                  </div>
                </div>
              </div>
            `;
          },
          /* eslint-enable */
        },
      }),

      customPagination({
        container: document.querySelector('.js-course-search-pagination'),
      }),
    ]);
  }
}

export default CourseSearch;
